import React, { useMemo } from 'react';
import { Table } from 'antd';
import moment from 'moment';

import formatPrice from '~helpers/currency';
import Card from '~client/components/card';

export default function ProductInfo({ t, productInfo = {} }) {
  const calcTenancyLength = (moveIn, moveOut) => {
    const diffDate = moment(moveOut).diff(moment(moveIn), 'days');

    let tenancyDesc = '';
    if (diffDate > 0) {
      if (diffDate < 7) {
        tenancyDesc = t('landlord.longtail_enquiry.property_card.only_days.tenancy_desc', {
          days: diffDate % 7,
        });
      } else if (diffDate % 7) {
        tenancyDesc = t('landlord.longtail_enquiry.property_card.have_days.tenancy_desc', {
          weeks: Math.floor(diffDate / 7),
          days: diffDate % 7,
        });
      } else {
        tenancyDesc = t('landlord.longtail_enquiry.property_card.only_weeks.tenancy_desc', {
          weeks: diffDate / 7,
        });
      }
    }
    return tenancyDesc;
  };

  const columns = useMemo(
    () => [
      {
        title: t('cms.booking.manual_property.detail.product_info.property'),
        dataIndex: 'propertyName',
        key: 'propertyName',
        width: 172,
        render: (_, record) => (
          <span className="table-field">{record?.interestedXbooking?.propertyName ?? '-'}</span>
        ),
      },
      {
        title: t('cms.booking.manual_property.detail.product_info.room_type'),
        dataIndex: 'roomType',
        key: 'roomType',
        width: 144,
        render: (_, record) => (
          <span className="table-field">
            {record?.interestedXbooking?.roomType
              ? t(`cms.table.value.category.${record?.interestedXbooking?.roomType.toLowerCase()}`)
              : '-'}
          </span>
        ),
      },
      {
        title: t('cms.booking.manual_property.detail.product_info.Room'),
        dataIndex: 'roomName',
        key: 'roomName',
        width: 132,
        render: (_, record) => (
          <span className="table-field">{record?.interestedXbooking?.roomName ?? '-'}</span>
        ),
      },
      {
        title: t('cms.booking.manual_property.detail.product_info.sales_price'),
        dataIndex: 'salesPrice',
        key: 'salesPrice',
        width: 120,
        render: (_, record) => (
          <span className="table-field">
            {record?.interestedXbooking?.unitPrice
              ? formatPrice(
                  record?.interestedXbooking?.unitPrice,
                  record?.interestedXbooking?.currency,
                )
              : '-'}
          </span>
        ),
      },
      {
        title: t('cms.booking.manual_property.detail.product_info.sales_type'),
        dataIndex: 'salesType',
        key: 'salesType',
        width: 144,
        render: (_, record) => (
          <div className="table-field">
            {record?.interestedXbooking?.billingCycle
              ? t(
                  `cms.booking.manual_property.detail.product_info.${record?.interestedXbooking?.billingCycle.toLowerCase()}`,
                )
              : '-'}
          </div>
        ),
      },
      {
        title: t('cms.booking.manual_property.detail.product_info.tenancy'),
        dataIndex: 'tenancy',
        key: 'tenancy',
        width: 144,
        render: (_, record) => (
          <div className="table-field">
            {record?.finalMoveInDate && record?.finalMoveOutDate
              ? calcTenancyLength(record?.finalMoveInDate, record?.finalMoveOutDate)
              : '-'}
          </div>
        ),
      },
      {
        title: t('cms.booking.manual_property.detail.product_info.discount'),
        dataIndex: 'discount',
        key: 'discount',
        width: 128,
        render: (_, record) => <div className="table-field">{record?.note ?? '-'}</div>,
      },
      {
        title: t('cms.booking.manual_property.detail.product_info.total_price'),
        dataIndex: 'totalPrice',
        key: 'totalPrice',
        width: 144,
        render: (_, record) => (
          <div className="table-field">
            {record?.finalPrice
              ? formatPrice(record?.finalPrice, record?.interestedXbooking?.currency)
              : '-'}
          </div>
        ),
      },
    ],
    [],
  );

  return (
    <Card id="product_info" title={t('landlord.long_tail.booking_details.label.product_info')}>
      <Table
        className="table-wrapper"
        columns={columns}
        dataSource={[productInfo]}
        pagination={false}
      />
    </Card>
  );
}
